import { convertToBehaviorSubject, distinctUntilChangedDeep } from '@core/shared/utils';
import { BehaviorSubject, combineLatest, map } from 'rxjs';
const DEFAULT_STATE = {
  valid: true,
  status: 'VALID',
  busy: false,
  hasTriedToSubmitForm: false,
  saveState: 'idle',
  isChanged: false,
  changeState: 'unchanged',
  editMode: null,
  formType: 'form'
};
export class FormState {
  constructor(name = 'unnamed') {
    this.saveState$ = new BehaviorSubject(DEFAULT_STATE.saveState);
    this.validationStatus$ = new BehaviorSubject(DEFAULT_STATE.status);
    this._isBusyInternal$ = new BehaviorSubject(DEFAULT_STATE.busy);
    this.isChanged$ = new BehaviorSubject(DEFAULT_STATE.isChanged);
    this.hasTriedToSubmitForm$ = new BehaviorSubject(DEFAULT_STATE.hasTriedToSubmitForm);
    this.editMode$ = new BehaviorSubject(null);
    this.isBusy$ = combineLatest({
      saveState: this.saveState$,
      isBusy: this._isBusyInternal$
    }).pipe(map(({
      saveState,
      isBusy
    }) => {
      return isBusy || saveState === 'saving';
    }));
    this._state$ = combineLatest({
      saveState: this.saveState$,
      status: this.validationStatus$,
      busy: this.isBusy$,
      isChanged: this.isChanged$,
      editMode: this.editMode$,
      hasTriedToSubmitForm: this.hasTriedToSubmitForm$
    }).pipe(map(({
      saveState,
      status,
      busy,
      isChanged,
      hasTriedToSubmitForm,
      editMode
    }) => {
      const state = {
        valid: status === 'VALID',
        status,
        busy,
        hasTriedToSubmitForm,
        saveState,
        editMode,
        isChanged,
        formType: editMode ? 'editor' : 'form',
        changeState: isChanged ? 'changed' : 'unchanged'
      };
      return state;
    }), distinctUntilChangedDeep()
    // shareReplay(1)
    );
    this.state$ = convertToBehaviorSubject(DEFAULT_STATE)(this._state$);
    this.name = name;
  }
  setName(name) {
    this.name = name;
  }
  setSaveState(value) {
    this.saveState$.next(value);
  }
  setValidationStatus(value) {
    this.validationStatus$.next(value);
  }
  setBusy(value) {
    this._isBusyInternal$.next(value);
  }
  setIsChanged(value) {
    this.isChanged$.next(value);
  }
  setEditMode(value) {
    this.editMode$.next(value);
  }
  setHasTriedToSubmitForm(value) {
    this.hasTriedToSubmitForm$.next(value);
  }
  reset(options = {}) {
    this.saveState$.next(DEFAULT_STATE.saveState);
    this.validationStatus$.next(DEFAULT_STATE.status);
    this._isBusyInternal$.next(DEFAULT_STATE.busy);
    this.isChanged$.next(DEFAULT_STATE.isChanged);
    this.hasTriedToSubmitForm$.next(DEFAULT_STATE.hasTriedToSubmitForm);
    if (!options.keepEditMode) this.editMode$.next(null);
  }
  getState$() {
    return this.state$.asObservable();
  }
  getState() {
    return this.state$.getValue();
  }
  getIsBusy$() {
    return this.isBusy$;
  }
  getIsChanged$() {
    return this.isChanged$.asObservable();
  }
  getSaveState$() {
    return this.saveState$.asObservable();
  }
  getEditMode$() {
    return this.editMode$.asObservable();
  }
}